<template>
  <div style="background-color: #f7f8fa">
    <van-nav-bar style="background-color: #42b983">
      <template #title>
        <span style="color: #ffffff">个人中心</span>
      </template>
      <template #left>
        <router-link to="/">
          <van-icon name="arrow-left" color="#ffffff"/>
          <span style="color: #ffffff">返回</span>
        </router-link>
      </template>
      <template #right>
        <router-link to="/">
          <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
        </router-link>
      </template>
    </van-nav-bar>

    <br>

    <van-row type="flex" justify="center">
      <van-col offset="2" span="6">
        <van-image round width="4rem" height="4rem" :src="user.avatar"/>
      </van-col>
      <van-col span="16">
        {{ user.nickname }}(ID:{{ user.id }})<br>
        <span style="font-size: 0.5rem">启用日期：{{ user.created_at }}</span><br>
        <span style="font-size: 0.5rem">今日模拟：1次</span>
      </van-col>
    </van-row>

    <br>

    <van-cell-group>
      <van-cell title="我的充值科目" is-link to="/vip"/>
      <van-cell title="我的订单" is-link to="/my/orders"/>
      <van-cell title="我的充值号" is-link to="/cd_key"/>
      <van-cell title="我要分享" is-link :to="getShareUrl()"/>
      <van-cell title="清除缓存" @click="cleanCache" is-link/>
      <van-cell title="清除本地错题" @click="cleanCt" is-link/>
      <van-cell title="我的学习记录" to="/learns" is-link/>
    </van-cell-group>

    <van-cell-group v-if="user.is_manger" :title="'机构专区(ID:'+user.organ_id+')'">
      <van-cell title="我的学员" is-link to="/organ/users?is_organ=1"/>
      <van-cell title="我的二维码" is-link to="/share"/>
      <van-cell title="学员充值情况" is-link to="/organ/orders?is_organ=1"/>
      <van-cell title="允许其他用户查看学员情况" is-link to="/organ/mangers"/>
    </van-cell-group>


    <van-cell-group v-if="user.is_admin" title="管理功能">
      <van-cell title="查看用户情况" is-link to="/organ/users"/>
      <van-cell title="学员充值情况" is-link to="/organ/orders"/>
      <van-cell title="合作伙伴列表" is-link to="/organs"/>
      <van-cell title="生成充值号" is-link to="/admin/create_cd_key"/>
      <van-cell title="人工确认用户充值" is-link to="/admin/pay_confirm"/>
      <van-cell title="更改用户充值科目" is-link to="/admin/change_subject"/>
      <van-cell title="设置/修改合作伙伴" is-link to="/admin/organ"/>
      <van-cell title="代理统计" is-link to="/admin/agent_statistics"/>
    </van-cell-group>

  </div>
</template>

<script>
export default {
  data() {
    return {
      subject_name: "",
      user: {},
    };
  },
  created() {
    this.getUserDetails()
  },
  methods: {
    getUserDetails() {
      this.$http.get("/wechat/user/details").then(res => {
        if (200 === res.data.code) {
          this.user = res.data.data.user
          this.subject_name = res.data.data.user.subject_name
        }
      }).catch(err => {
        console.log("my error",err)
        if (err.message==="Request failed with status code 401" ) {
          // 401 清除token信息并跳转到登录页面
          window.localStorage.setItem('token', '');
          // router.replace({path: '/login'});
          window.location.href = "/login"
        }
      });
    },
    getShareUrl() {
      if (this.user.organ_id > 0) {
        return "/share?organ_id=" + this.user.organ_id;
      } else {
        return "/share";
      }
    },
    cleanCache() {
      this.$dialog.confirm({
        title: '清除缓存',
        message: '确定要清除缓存吗？',
      }).then(() => {
        window.localStorage.clear()
        window.indexedDB.deleteDatabase("examination")
      }).catch(() => {
        // on cancel
      });
    },
    cleanCt() {
      this.$dialog.confirm({
        title: '清除错题',
        message: '确定要清除错题吗？',
      }).then(() => {
        this.$http.delete("/wechat/clean_wrong_topic").then(res => {
          console.log(res.data);
        });
      }).catch(() => {
        // on cancel
      });
    },

  }
}
</script>
